var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('custom-select',{attrs:{"label":"Nacionalidad","value":_vm.value,"name":_vm.name,"items":_vm.nacionalidades,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onChange,"click":function($event){return _vm.$emit('click')},"onFocus":function($event){return _vm.$emit('onFocus')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }